import { render, staticRenderFns } from "./custom-input.vue?vue&type=template&id=540ac97e&scoped=true"
import script from "./custom-input.vue?vue&type=script&lang=js"
export * from "./custom-input.vue?vue&type=script&lang=js"
import style0 from "./custom-input.vue?vue&type=style&index=0&id=540ac97e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540ac97e",
  null
  
)

export default component.exports